import { HeatmapBaseRenderer } from './HeatmapBaseRenderer';
export class HeatmapAreaBaseRenderer extends HeatmapBaseRenderer {
    drawHeaderText(gr, areaName, font, headerForegroundBrush, headerTextRectangle, horizontalAlign = 'left') {
        gr.DrawStringInRect(areaName, font, headerForegroundBrush, headerTextRectangle, false, horizontalAlign, 'middle', true);
    }
}
HeatmapAreaBaseRenderer.SELECTOR_SIGN = '>';
